import styles from "./index.module.css";
import gpuownericon from "../../icons/gpuowner.svg";
import SquareProof from "../SquareProof/SquareProof";
import LargeRigthLine from "../LargeRigthLine/LargeRigthLine";
import LagreLeftLine from "../LargeLeftLine/LagreLeftLine";
import TopProofArrow from "../TopProofArrow/TopProofArrow";

const ProofWork = () => {
  return (
    <div className={styles.proofWork}>
      <div className={styles.textBlock}>
        <h3 className={styles.title}>ProoF of WORK</h3>

        <p className={styles.description}>
          {" "}
          Analyzes the non-fungible token (NFT) market, using image recognition
          and market data to evaluate and recommend NFT investments. GPUs
          accelerate the processing of complex algorithms that assess rarit.
        </p>
      </div>
      <div className={styles.proofScheme}>
        <button className={styles.gpuBtn}>
          {" "}
          <span>GPU OWNER </span> <img src={gpuownericon} alt="gpuownericon" />
        </button>
        <SquareProof />

        <TopProofArrow />
        <LargeRigthLine />
        <LagreLeftLine />
      </div>
    </div>
  );
};

export default ProofWork;
